import {
    type ProductListViewModel,
    ProductListHeaderDiscriminator as ProductListViewModelpageHeaderDiscriminator
} from 'autogen/swagger/all';
import ExtendedPlaceholder from 'components/pages/placeholders/ExtendedPlaceholder';
import Header from 'components/plp/BrandGifts/Header';
import BrandHeader from './components/BrandHeader';
import HeadlineHeader from './components/HeadlineHeader';
import TextHeader from './components/TextHeader';

export default function ProductListPageHeader({ model }: { model: ProductListViewModel['pageHeader'] }) {
    return ProductListViewModelpageHeaderDiscriminator(
        model,
        (bonusGiftModel) => (
            <Header model={{ headline: bonusGiftModel.name, description: bonusGiftModel.description }} />
        ),
        (brandModel) => <BrandHeader model={brandModel} />,
        (offerModel) => (
            <ExtendedPlaceholder model={offerModel.extendedPlaceholderModel} shouldDisplayAsH1 addHorizontalPadding />
        ),
        (rebuyModel) => <HeadlineHeader model={rebuyModel} />,
        (textModel) => <TextHeader model={textModel} />,
        () => null
    );
}
